module.exports = __webpack_public_path__ + "static/together_bg3_1_m-7e68b8da802d5b2280138bc054831118.png";